<template>
  <v-sheet
    class="kiwi-my-practice-page kiwi-mock-test kiwi-bg-white kiwi-test-black pa-0 kiwi-radius-8 overflow-hidden border kiwi-border-light-grey-3"
    variant="flat"
  >
    <v-sheet class="kiwi-mock-test-header py-3 px-4" variant="flat">
      <div class="d-flex flex-wrap align-center">
        <img
          src="/assets/mortarboard-02.svg"
          width="36"
          height="36"
          class="mr-2"
        />
        <span class="font-weight-bold kiwi-fs-20" style="flex: 1"
          >Question Based Tests</span
        >
      </div>
    </v-sheet>
    <v-divider></v-divider>
    <v-sheet class="pt-3 px-2" variant="flat">
      <v-tabs  hide-slider>
        <v-tab
          v-for="(menu, i) in tabs"
          :key="i"
          :class="activeQTab === menu.id ? ' kiwi-bg-primary qbt-active-tab-menu kiwi-text-white' : ''"
          class="mr-2 kiwi-border-light-grey-4 text-none kiwi-text kiwi-text-light-black-2 qbt-tab-menu"
          style="border: 1px solid transparent; border-radius: 8px 8px 0 0"
          @click.prevent="setActiveTab(menu.id)"
          ><img :src="activeQTab === menu.id ? menu.icon_w : menu.icon" class="mr-2 size-18" /> {{ menu.label }}</v-tab
        >
      </v-tabs>
    </v-sheet>
    <v-divider class="kiwi-border-primary"></v-divider>
    <v-sheet variant="flat">
      <v-sheet
        class="kiwi-bg-light-grey-7 py-2 px-6 d-flex flex-wrap"
        variant="flat"
        style="margin: 0 -8px"
      >
        <template v-if="!store.isSAT">
        <v-chip
          label
          class="ma-1 kiwi-fs-14 forn-weight-semi-bold kiwi-qbt-topic border kiwi-radius-4 kiwi-text-light-black-2"
          variant="flat"
          :class="
            list.id === activeTopic
              ? 'kiwi-bg-primary-dim-50 kiwi-text-primary-overwrite kiwi-border-primary font-weight-semi-bold'
              : 'kiwi-bg-white kiwi-bg-black'
          "
          v-for="(list, i) in chapterItems"
          :key="i"
          @click.prevent="activeTopic = list.id"
          size="large"
          style="font-size: 14px;"
        >
          {{ list.title }}
        </v-chip>
        </template>
        <template v-else>
          <v-row>
            <v-col col="12" md="3" v-for="(math, i) in satChapterItems" :key="i">
              <div class="kiwi-form-group form-group mb-3">
                <label for="" class="kiwi-form-label font-weight-bold kiwi-text-light-black-3 text-uppercase" style="font-size: 12px !important;">{{math.title}}</label
                >
                <v-select
                  class="kiwi-form-input qbt-filter-input kiwi-radius-4 kiwi-bg-white"
                  :items="math.children"
                  :placeholder="math.children[0].title.slice(0, 40)+'...'"
                  hide-details
                  variant="outlined"
                  :v-model="activeChapter"
                  @update:modelValue="getQuestionsForSat"
                  :item-value="'id'"
                ></v-select>
              </div>
            </v-col>
          </v-row>
        </template>
      </v-sheet>
      <v-divider></v-divider>
      <div class="text-center pb-10 pt-10 mt-10 mb-10" v-if="fetching.tests">
        <Loading  />
      </div>
      <v-sheet class="kiwi-mock-test-content py-3 px-4" variant="flat" v-else
        >
        <template v-if="!store.isSAT">
        <Test
          v-for="(test, i) in questionsBasedTests"
          :key="i"
          class="my-4"
          :test="test"
          :type="'question-based'"
        />
        </template>
        <template v-else>
          <v-row class="mt-0 mb-2">
            <v-col sm="6"  md="6" lg="3" xs="12" v-for="(test, i) in questions" :key="i">
              <TestGrid :type="'question-based'" :test="test" :satMode="true"  :is-qbt="true"/>
            </v-col>
          </v-row>
        </template>
      </v-sheet>
    </v-sheet>
    <v-divider></v-divider>

    <div>
      <v-sheet class="kiwi-bg-light-grey-7 kiwi-text-black py-3 px-4">
        <v-row>
          <v-col cols="12" md="6">
            <div class="d-flex align-center">
              <v-select
                border
                class="kiwi-bg-white kiwi-border-light-grey-6 mr-2 limit-select"
                :items="[10, 15, 20, 25]"
                v-model="pagination.pageSize"
                flat
                variant="outlined"
                placeholder="1"
                hide-details
                style="max-width: 90px;"
                @update:modelValue="() => { pagination.page = 1; getQuestionBasedTests(activeTopic) }"
              ></v-select>
            <span v-if="questionsBasedTests.length">Showing: {{ showing }} to {{ showing + questionsBasedTests.length - (showing === 1 ?  1 : 0)  }} </span>
            </div>
          </v-col>
          <v-col cols="12" md="6" class="text-right">
            <v-pagination
              v-model="pagination.page"
              :length="pageCount"
              :total-visible="pagination.pageSize"
              variant="text"
              @update:modelValue="getQuestionBasedTests(activeTopic)"
              density="compact"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-sheet>
    </div>
  </v-sheet>
</template>

<script setup>
import Test from "@/components/Dashboard/QuestionCard.vue";
import TestGrid from "@/components/Dashboard/TestGrid.vue";
import { ref, onMounted, computed, watch , nextTick} from "vue";
import { useQustionsBasedTestStore } from "@/stores/questionBased-store";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";
import {useAuthStore} from '@/stores/auth/authStore';
import {useQuestionBasedSatStore} from "@/stores/Sat/questionBasedSat-store";
import {tr} from "vuetify/locale";

const activeChapter = ref(null);
const route = useRoute();
const store = useAuthStore();
const questionBasedStore = useQustionsBasedTestStore();
const questionBasedSatStore = useQuestionBasedSatStore();
const {getTopics , getQuestions} =questionBasedSatStore;
const {satTopics} = storeToRefs(questionBasedSatStore);
const { getQuestionBasedTests, getAllTopics } = questionBasedStore;
const { questionsBasedTests, pagination, total, topics, fetching } =
storeToRefs(questionBasedStore);
const {questions} = storeToRefs(questionBasedSatStore);
pagination.value.page = 1
const paginationLimiter = ref(10);
const pageCount = computed(() => {
  return Math.ceil(total.value / pagination.value.pageSize);
});
const activeQTab = ref(route.query.m ? parseInt(route.query.m) : null);

const iconMap = {
    speaking: {
        icon: '/assets/voice_black.svg',
        icon_w: '/assets/voice_white.svg',
    },
    writing: {
        icon: '/assets/pencil-edit-01_black.svg',
        icon_w: '/assets/pencil-edit-01_white.svg',
    },
    reading: {
        icon: '/assets/book-open-black.svg',
        icon_w: '/assets/book-open-white.svg',
    },
    listening: {
        icon: '/assets/headphones-black.svg',
        icon_w: '/assets/headphones-white.svg',
    },
    reading_and_writing: {
        icon: '/assets/book-open-black.svg',
        icon_w: '/assets/book-open-white.svg',
    },
    math: {
        icon: '/assets/pen-tool-black.svg',
        icon_w: '/assets/pen-tool-white.svg',
    },
}
const satChapterItems = computed(() => {
  if (satTopics.value.length > 0) {
    const topic =  satTopics.value.find(t => t.id === activeQTab.value)
    if(!topic) {
      return [];
    }
    return topic.children
  }
});
watch(satChapterItems, (newVal, oldVal) => {
  if(newVal) {
    activeChapter.value = newVal[0]?.children[0]?.id;
    getQuestions(activeChapter.value);
  }
})

const tabs = computed(() => {
     if(store.isSAT && satTopics.value.length > 0){
       return satTopics.value.map(topic => {
         return {
           ...(iconMap[topic.slug] || {}),
           label: topic.title,
           value: topic.slug,
           id: topic.id,
         }
       })
     }
    return topics.value.map(topic => {
        return {
            ...(iconMap[topic.slug] || {}),
            label: topic.title,
            value: topic.slug,
            id: topic.id,
        }
    })
})

const activeTopic = ref(route.query.topic ? parseInt(route.query.topic) : null);
const setActiveTab = (module) => {
    activeQTab.value = module
    activeTopic.value = null
}
const chapterItems = computed(() => {
    const topic =  topics.value.find(t => t.id === activeQTab.value)
    if(!topic) {
        return [];
    }
    return topic.children
})
watch(topics, (newVal, oldVal) => {
    if(!activeQTab.value && newVal.length) {
      activeQTab.value = topics.value[0].id
    }
}, {immediate: true, deep: true})
watch(activeQTab, (newVal, oldVal) => {
    if(activeQTab.value && !activeTopic.value && chapterItems.value.length) {
       activeTopic.value = chapterItems.value[0].id
    }
}, {immediate: true, deep: true})

watch(activeTopic,  (newVal, oldVal) => {
    if(activeTopic.value) {
      pagination.value.page = 1
      getQuestionBasedTests(activeTopic.value)
    }
}, {immediate: true})

watch(chapterItems , (newVal , oldVal) =>{
  if (newVal) {
    const matchingTopic = topics.value.find(topic => {
      return topic.children.find(child => child.id === activeTopic.value);
    });
    if(matchingTopic && !activeQTab.value) {
      activeQTab.value= matchingTopic.id;
    }
  }
})
if(store.isSAT){
  await getTopics();
  activeQTab.value = satTopics.value[0]?.id;
}else {
  getAllTopics()
}
const showing = computed(() => {
  return pagination.value.page <= 1 ? 1 : (pagination.value.pageSize * (pagination.value.page - 1))
})
const getQuestionsForSat = (val) =>{
  getQuestions(val);
}
</script>

<style lang="scss">
.kiwi-bg-white {
  .v-field__input, .v-field__overlay {
    background: white !important;
  }
}
.kiwi-form-group {
  .qbt-form-input {
    .v-field__input {
      min-height: 44px;
      height: 44px;
    }
  }
}
</style>
